module.exports = __webpack_public_path__ + "img/cooperation_unit_06.4b8dab31.png";